var funcs: any = {
  // Title
  element1: function (data: any) {
    return `<h1 class="h1 color1" style="min-width: 450px; font-family: sans-serif; line-height: 1.4; margin: 0; font-size: 19px; font-weight: 700; text-align: center; text-transform: capitalize; margin-top: 20px; margin-bottom: 27px; color: #33A8F0;">${data[0]}</h1>`
  },

  // Explain
  element2: function (data: any) {
    return `<h4 class="h4" style="color: #222222; font-family: sans-serif; line-height: 1.4; margin: 0; text-align: center; font-size: 14px; font-weight: 500; margin-bottom: 16px;">${data[0]}</h4>`
  },

  // Property1 with Dangerous Html
  element10: function (data: any) {
    return `<h4 class="h4" style="color: #222222; font-family: sans-serif; line-height: 1.4; margin: 0; text-align: center; font-size: 14px; font-weight: 500; margin-bottom: 16px;">${data[0]}: <br/><p style="text-align: left;">${data[1]}</p></h4>`
  },

  // Property1
  element3: function (data: any) {
    return `<h4 class="h4" style="color: #222222; font-family: sans-serif; line-height: 1.4; margin: 0; text-align: center; font-size: 14px; font-weight: 500; margin-bottom: 16px;">${data[0]}: <br/><span class="bold" style="font-weight: 700;">${data[1]}</span></h4>`
  },

  // Property2 color
  element4: function (data: any) {
    return `<h4 class="h4" style="color: #222222; font-family: sans-serif; line-height: 1.4; margin: 0; text-align: center; font-size: 14px; font-weight: 500; margin-bottom: 16px;">${data[0]}: <br/><span class="bold color1" style="font-weight: 700; color: #33A8F0;">${data[1]}</span></h4>`
  },

  // Title sub1
  element5: function (data: any) {
    return `<h2 class="h2" style="color: #222222; font-family: sans-serif; line-height: 1.4; margin: 0; text-align: center; font-size: 16px; font-weight: 600; margin-bottom: 15px; margin-bottom: 20px;">${data[0]}</h2>`
  },

  // Button Link
  element6: function (data: any) {
    return `<table border="0" cellpadding="0" cellspacing="0" class="btn btn-primary" style="border-collapse:separate;mso-table-lspace:0;mso-table-rspace:0;box-sizing:border-box;width:100%;min-width:100%;margin-top: 20px;" width="100%"><tbody><tr><td align="center" style="font-family:sans-serif;font-size:14px;vertical-align:top;padding-bottom:15px" valign="top"><table border="0" cellpadding="0" cellspacing="0" style="border-collapse:separate;mso-table-lspace:0;mso-table-rspace:0;width:auto"><tbody><tr><td style="font-family:sans-serif;font-size:14px;vertical-align:top;border-radius:5px;text-align:center;background-color:#33a8f0" valign="top" align="center" bgcolor="#33A8F0"><a class="a" href="${data[0]}" target="_blank" style="border:solid 1px #3498db;border-radius:5px;box-sizing:border-box;cursor:pointer;display:inline-block;font-size:14px;font-weight:700;margin:0;padding:12px 40px;text-decoration:none;text-transform:capitalize;background-color:#33a8f0;border-color:#33a8f0;color:#fff">${data[1]}</a></td></tr></tbody></table></td></tr></tbody></table>`
  },

  // Link
  link: function (data: any) {
    return `<div style="text-align:left"><a class="a" href="${data[0]}" target="_blank" style="box-sizing:border-box;cursor:pointer;display:inline-block;font-size:14px;font-weight:700;margin:0;padding:12px 0;text-decoration:none;text-transform:capitalize">${data[1]}</a></div>`
  },

  // Button Link (Yes, No)
  element9: function (data: any) {
    return `<table border="0" cellpadding="0" cellspacing="0" class="btn btn-primary" style="border-collapse:separate;mso-table-lspace:0;mso-table-rspace:0;box-sizing:border-box;width:100%;min-width:100%;margin-top:20px" width="100%"><tbody><tr><td align="center" style="font-family:sans-serif;font-size:14px;vertical-align:top;padding-bottom:15px" valign="top"><table border="0" cellpadding="0" cellspacing="0" style="border-collapse:separate;mso-table-lspace:0;mso-table-rspace:0;width:auto"><tbody><tr><td style="font-family:sans-serif;font-size:14px;vertical-align:top;border-radius:5px;text-align:center" valign="top" align="center"><a class="a" href="${data[0]}" target="_blank" style="border:solid 1px #3498db;border-radius:5px;box-sizing:border-box;cursor:pointer;display:inline-block;font-size:14px;font-weight:700;margin:0;padding:12px 40px;text-decoration:none;text-transform:capitalize;background-color:#33a8f0;border-color:#33a8f0;color:#fff;margin-right:10px">${data[1]}</a><a class="a" href="${data[2]}" target="_blank" style="border:solid 1px #3498db;border-radius:5px;box-sizing:border-box;cursor:pointer;display:inline-block;font-size:14px;font-weight:700;margin:0;padding:12px 40px;text-decoration:none;text-transform:capitalize;background-color:#b91c1c;border-color:#b91c1c;color:#fff;margin-left:10px">${data[3]}</a></td></tr></tbody></table></td></tr></tbody></table>`
  },

  // Property1: value (Horizontal)
  element7: function (data: any) {
    return `<h4 class="h4" style="color: #222222; font-family: sans-serif; line-height: 1.4; margin: 0; text-align: left; font-size: 14px; font-weight: 500; margin-bottom: 12px;">${data[0]}: <span class="bold" style="font-weight: 600; margin-left: 10px">${data[1]}</span></h4>`
  },

  // Title sub1 Left
  element8: function (data: any, fontSize: number = 16) {
    return `<h2 class="h2" style="color: #222222; font-family: sans-serif; line-height: 1.4; margin: 0; text-align: left; font-size: ${fontSize}px; font-weight: 600; margin-top: 16px; margin-bottom: 10px;">${data[0]}</h2>`
  },

  // Explain Left
  element11: function (data: any) {
    return `<h4 class="h4" style="color: #222222; font-family: sans-serif; line-height: 1.4; margin: 0; text-align: left; font-size: 14px; font-weight: 500; margin-bottom: 16px;">${data[0]}</h4>`
  },

  // Table Header
  table: function (header: string[], body: string[][]) {
    return (
      `<table width="100%" style="margin-bottom: 16px;">` +
      emailFuncs.tableHeader(header) +
      `<tbody>` +
      body.map((row) => emailFuncs.tableCell(row)).join('') +
      `</tbody></table>`
    ).replace(/\s\s+/g, ' ')
  },
  tableHeader: function (data: string[]) {
    return (
      `<thead style="background-color: #eee">
      <tr>` +
      data
        .map(
          (v) => `<th
                    style="
                      border-bottom: 1px solid #f2f2f2;
                      font-size: 13px;
                      color: #333;
                      line-height: 1.4;
                      text-align: left;
                      padding-left: 10px;
                      text-transform: uppercase;
                      padding: 5px;
                    "
                  >
                    ${v}
                  </th>`,
        )
        .join('') +
      `</tr>
    </thead>`
    )
  },

  tableCell: function (data: string[]) {
    return (
      `<tr>` +
      data
        .map(
          (v) => `<td
                    style="
                      border-bottom: 1px solid #f2f2f2;
                      text-align: left;
                      font-size: 13px;
                      padding-left: 10px;
                      padding: 5px;
                      color: #444;
                    "
                  >
                    ${v}
                  </td>`,
        )
        .join('') +
      `</tr>`
    )
  },
}

export const emailFuncs = funcs

export function getEmailHtml(list: Array<{ type: string; data: any }>, originalTemplate: string) {
  let content = ''
  list
    .filter((v) => !!v)
    .map((item) => {
      const { type, data } = item
      if (type === 'table') content += funcs[type](data[0], data[1])
      else content += funcs[type](data)
    })
  let message = originalTemplate
  message = message.replace('{{content}}', content)
  return message
}
